













































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    //import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
    import { classPrintWorld } from '@/common/js/PrintWorld'
    import UpdatebackstockreturnorderStatu from '@/store/entities/back-updatestatus'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'
    import DestructionStatu from './destruction-stockreturnorder.vue'
    //import BaleStockOrder from './bale-abroadorder.vue'
    import moment from 'moment'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import VueClipboard from 'vue-clipboard2'
    import { Select } from '../../../types/iview/select';
    Vue.use(VueClipboard)


    class PageOrderRequest extends PageRequest {
        site?: number;
        cargoCategory?: number;
        SearchInfo: string;
        userCode: string;
        BeginTime?: Date;
        EndTime?: Date;
        source?: number;
        storeId?: number;
        status?: number;
        productName: string;
        PlatformType?: number;
        constructor() {
            super();
            this.site = null;
            this.status = null;
            this.cargoCategory = null;
            this.source = null;
        }
    }

    @Component({
        name: "backstockreturnorder",
        components: { DestructionStatu, }

    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        receivedTime: Date[] = [];
        siteStatus = Enums.getEnum(Enums.SiteSType, true);
        CargoCategoryTypeList = Enums.getEnum(Enums.CargoCategoryType, true);
        StatusList = Enums.getEnum(Enums.ReturnOrderStatus, true);
        ReturnOrderStatus = Enums.getEnum(Enums.ReturnOrderSource, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);

        updateOderStatuShow = false;
        destructionModel: boolean = false;
        editModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        automaticJump: boolean = true;
        isLoadPrintList: boolean = false;
        flag: boolean = false;
        baleStockOrderModal: boolean = false;
        orderNumberList: string[] = [];
        logisticsList: string[] = [];
        BaseSkuNums: number[] = [];
        get list() {
            return this.$store.state.backstockreturnorder.list;
        };
        get loading() {
            return this.$store.state.backstockreturnorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('backstockreturnorder/setCurrentPage', page);
            this.getpage();
        }
        handleChangeImg($event) {
            if ($event.currentTarget.className == 'img') {
                $event.currentTarget.className = 'img open';
            } else {
                $event.currentTarget.className = 'img';
            }
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backstockreturnorder/setPageSize', pagesize);
            this.getpage();
        }

        @Watch('$route.params.inputShipment')
        inputShipmentChange() {
            var s = '';
            if (this.$route.params.inputShipment) {
                this.pagerequest = new PageOrderRequest();
                this.pagerequest.SearchInfo = this.$route.params.inputShipment;
                this.$store.state.backstockreturnorder.currentPage = 1;
                this.getpage();
            }

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);

        }
        async Destruction(data) {
            this.$store.state.backstockreturnorder.id = data.id;
            this.destructionModel = true;
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'backstockreturnorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }

        async searchPage() {
            this.$store.state.backstockreturnorder.currentPage = 1;
            this.getpage();
        }

        get pageSize() {
            return this.$store.state.backstockreturnorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.backstockreturnorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.backstockreturnorder.currentPage;
        }


        copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }


        columns = [
            {
                title: '仓储名称',
                key: 'storeName',
                width: 150,
            },
            {
                title: '用户编号',
                key: 'userCode',
                width: 90,
            },
            {
                title: '退件入库状态',
                width: 120,
                key: 'status',
                render: (h: any, params: any) => {
                    return h('span', Enums.ReturnOrderStatus.filter(function (item) { return item.value == params.row.status })[0].name);
                }
            },
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
            },
            {
                title: '退件类码',
                key: 'returnNo',
                width: 170,
            },
            {
                title: '退件编号',
                key: 'returnNumber',
                width: 150,
            },
            {
                title: '退件订单来源',
                width: 120,
                key: 'source',
                render: (h: any, params: any) => {
                    return h('span', Enums.ReturnOrderSource.filter(function (item) { return item.value == params.row.source })[0].name);
                }
            },
            {
                title: '上架费',
                key: 'shelfCost',
                width: 150,
            },
            {
                title: '货架位置',
                key: 'shelfPosition',
                width: 150,
            },
            {
                title: '扣费周期',
                key: 'deductionCycle',
                width: 150,
            },
            {
                title: '扣费金额',
                key: 'deductIntegral',
                width: 150,
            },
            {
                title: '开始扣费时间',
                key: 'beginDeductionTime',
                width: 250,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
                }
            },

            {
                title: '商品信息',
                width: 300,
                key: '',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.productInfoList.map(item => {
                        var url = "";
                        if (item.url) {
                            url = item.url;
                        }
                        else {
                            var data = { imageGuid: item.productImgGuid, url: null };
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            var producturl = data.url;
                            url = producturl;
                        }
                        var img = url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), item.count]);
                    }));
                }
            },
            {
                title: '站点',
                width: 100,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            },
            {
                title: '货物类别',
                width: 90,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },

            {
                title: '备注',
                width: 200,
                key: 'remark',
                render: (h: any, params: any) => {
                    return h('div', [h('span', { style: { color: 'red' } }, params.row.remark)]
                    )
                }
            },

            {
                title: '销毁金额',
                key: 'destoryCost',
                width: 120,
            },

            {
                title: '时间',
                width: 300,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "退件到仓时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime))))])
                }
            },

            {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;

                    if (data.status == 2) {
                        return h('div', [

                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginTop: '5px',
                                    height: '30px',
                                    width: '68px',
                                },
                                on: {
                                    click: () => {
                                        this.Destruction(data);
                                    }
                                }

                            }, "销毁"),

                        ]);
                    }
                }
            }
        ]

        async created() {
            this.getData();
            this.getpage();

        }
        async mounted() {
        }
    }
